

// src/components/About.jsx
import React from "react";
import "../styles/about.css";

export default function About() {
  return (
    <section className="cp-about" aria-label="About Concerted Path">
      {/* ================= HERO ================= */}
      <div className="about-hero">
        <div className="about-hero-inner">
          <h1 className="about-title">About Concerted Path</h1>
          <p className="about-sub">
            One of the most experienced & recognised vocational training & placement institutes in India.
          </p>
        </div>
      </div>

      {/* ================= CONTENT ================= */}
      <div className="about-content">

        {/* ===== WHO WE ARE + IMAGE ===== */}
        <div className="about-grid cp-card">
          {/* TEXT */}
          <div className="about-text">
            <h2 className="section-heading">Who We Are</h2>

            <p>
              <strong>Concerted Path</strong> is one of the most experienced & recognised
              vocational training & placement institutes in India, incorporated by
              <strong> Mr. Santosh Kumar</strong> in 2017. Concerted Path is a pioneer in
              employment-oriented, computerized Accountancy & Taxation courses.
            </p>

            <p>
              Our main objective is to create professionals for the industries with the
              help of specially designed job-oriented courses. When we mention
              job-oriented courses, it means that our institute will provide equal
              opportunities to every student to work in the industry and use their skills
              in the practical world.
            </p>

            <p>
              Behind these specialized courses, there is a team of industry experts and
              brilliant minds, and our goal is to make our students aware of the most
              updated industrial knowledge & skills.
            </p>
          </div>

          {/* IMAGE */}
          <div className="about-image">
            <img
              src="/images/AboutUs.png"
              alt="Students learning accounting at Concerted Path"
            />
          </div>
        </div>

        {/* ===== OUR BELIEF ===== */}
        <div className="cp-card">
          <h2 className="section-heading">Our Belief</h2>

          <blockquote className="cp-quote">
            "Vocational education is not only the path to provide increased opportunities
            of employment to the students but also helps them to fill the gap of industrial
            skills among already employed professionals. Vocational training empowers
            individuals’ core working skills, provides industrial knowledge, and enhances
            confidence, which helps them face unknown future challenges."
          </blockquote>
        </div>

        {/* ===== MISSION, VISION & VALUES ===== */}
        <div className="cp-card">
          <h2 className="section-heading">Mission, Vision & Values</h2>

          <p>
            <em>
              "One of the main reasons given by students for going to university is to get
              a good job afterwards".
            </em>
          </p>

          <p>
            Every year, millions of students graduate in the field of commerce from
            various universities in India. Getting a job after graduation depends not
            only on the degree but on industrial skills and practical exposure,
            especially for Commerce graduates.
          </p>

          <p>
            Today, companies look for a broader set of skills — good communication,
            teamwork, problem-solving approach, positive attitude, enthusiasm and
            adaptability.
          </p>

          <p>
            These are the skills learned on the job; <strong>Concerted Path</strong> aims
            to give students that advantage while they are still studying.
          </p>

          <p>
            <strong>
              Concerted Path is dedicated to transforming a commerce graduate into a
              professional who can easily be placed in industry.
            </strong>{" "}
            We are one of a kind institute that not only trains students but also
            provides strong placement support and job assurance based on the skills
            students acquire with us.
          </p>
        </div>

      </div>
    </section>
  );
}
